import React, { createContext, useState, useEffect } from 'react';
import { LightAppTheme, DarkAppTheme } from '../theme';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(LightAppTheme);
  const [selectedTheme, setSelectedTheme] = useState('auto');
  const [zoomLevel, setZoomLevel] = useState(() => {
    const savedZoomLevel = localStorage.getItem('zoomLevel');
    return savedZoomLevel ? parseInt(savedZoomLevel, 10) : 100;
  });

  const setLightTheme = () => {
    setTheme(LightAppTheme);
    setSelectedTheme('light');
  };

  const setDarkTheme = () => {
    setTheme(DarkAppTheme);
    setSelectedTheme('dark');
  };

  const setAutoTheme = () => {
    const autoTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? DarkAppTheme : LightAppTheme;
    setTheme(autoTheme);
    setSelectedTheme('auto');
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setSelectedTheme(storedTheme);
      switch (storedTheme) {
        case 'light':
          setLightTheme();
          break;
        case 'dark':
          setDarkTheme();
          break;
        default:
          setAutoTheme();
          break;
      }
    } else {
      setAutoTheme();
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', selectedTheme);
  }, [selectedTheme]);

  useEffect(() => {
    localStorage.setItem('zoomLevel', zoomLevel);
    document.body.style.zoom = zoomLevel / 100;
  }, [zoomLevel]);

  return (
    <ThemeContext.Provider value={{ theme, selectedTheme, setLightTheme, setDarkTheme, setAutoTheme, zoomLevel, setZoomLevel }}>
      {children}
    </ThemeContext.Provider>
  );
};
